/**
 * App redactor Object
 *
 * @type object
 */
App.redactor = function() {

    /**
     * Object properties
     *
     * @type {App}
     */
    var _this = this;


    /**
     * Constructor
     *
     * Booting function
     *
     * @param element string
     */
    this.init = function(element) {
        this.createNewInstance(element);
        return this;
    };


    /**
     * Handle Basic redactor
     */
    this.createBasicNewInstance = function(element) {
        $(element).redactor({
            replaceDivs       : false,
            removeEmptyTags   : false,

            buttons : [
                'html', 'formatting', 'bold', 'italic', 'underline', 'deleted',
                'unorderedlist', 'orderedlist',
                'link', 'alignment', 'horizontalrule',
                'alignleft', 'aligncenter', 'alignright', 'justify'
            ]
        });
    }


    /**
     * Handle redactor
     */
    this.createNewInstance = function(element)
    {
        // Get the controller URL and initialize redactor
        var url         = $(element).data("url");
        var documentUrl = $(element).data("document-url");

        this.redactorObject = $(element).redactor({
            plugins           : ['advanced', 'advancedvideo', 'table', 'definedlinks'],
            focus             : false,
            minHeight         : 350,
            maxHeight         : 350,
            replaceDivs       : false,
            convertVideoLinks : true,
            removeEmptyTags   : false,
            toolbarFixed      : false,

            buttons : [
                'html', 'formatting', 'bold', 'italic', 'underline', 'deleted',
                'unorderedlist', 'orderedlist', 'outdent', 'indent', 'image',
                'link', 'alignment', 'horizontalrule', // 'file',
                'alignleft', 'aligncenter', 'alignright', 'justify'
            ],
            imageGetJson       : url + 'list',
            clipboardUploadUrl : url + 'copy',
            imageUpload        : url + 'upload',
            definedLinks    : documentUrl,
            uploadImageFields   : {'_token' : App.helper.getToken()},
            langs              : App.jquery.getRedactorLangs()
        });

        return this;
    };


    /**
     * Custom Video Plugin
     */
    this.handleAdvancedVideo = function(videos)
    {
        $.Redactor.prototype.advancedvideo = function()
        {
            return {
                init: function()
                {
                    if (!videos.length) {
                        return false;
                    }

                    $.each(videos, function(i, item) {

                        videos[i].title = item.name;

                        videos[i].func = function() {
                            this.insert.html('<p>[VIDEO_' + item.id + ']</p>');
                        };

                    });

                    var button = this.button.add('advancedvideo', 'Video');
                    this.button.addDropdown(button, videos);
                }
            };
        };
    };
};
